<template>
  <div>
    <!-- Slot Rules Modal -->
    <div
      v-show="slotRules"
      class="relative z-50"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="fixed inset-0 bg-black bg-opacity-70 transition-opacity"
        aria-hidden="true"
      ></div>
      <div
        class="fixed inset-0 z-10 w-screen overflow-y-auto"
        style="font-family: Oxanium, sans-serif"
      >
        <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
          <div
            v-motion-pop-visible
            class="relative overflow-hidden text-center shadow-xl sm:my-8 sm:w-full sm:max-w-xl rounded-[1rem] bg-[#1D1D1D]"
          >
            <div class="px-6 sm:px-10 pb-8 pt-6 sm:pt-10">
              <h3
                class="text-xl lg:text-3xl font-semibold text-white uppercase"
                id="modal-title"
              >
                KOTH SLOTS RULES
              </h3>
              <ol
                class="list-decimal text-left text-white mt-6 text-sm lg:text-base tracking-wider ml-5 space-y-4"
              >
                <li>
                  Use the Code <span class="text-[#1294F0] font-bold">"BALLYBOY"</span>.
                </li>
                <li>
                  Minimum Bet Requirement - Submit a Bet ID with at least $0.40 USD.
                </li>
                <li>
                  Achieve a Multi Above 500x - Only slot wins with 500x or higher are
                  eligible.
                </li>
                <li>
                  Must be registered via this link -
                  <a
                    href="https://metamedialinks.com/e36249d00"
                    target="_blank"
                    class="text-[#1294F0] underline"
                    >Registration link</a
                  >.
                </li>
                <li>Bets over $1.00 receive additional prize money 💰</li>
                <li>
                  Submit Your Multi’s Bet ID -
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSfjMYg9wYQckEdSYr4ZgfP3oR-DJnpQDOfbX2G6dVcvbYb7mw/viewform"
                    target="_blank"
                    class="text-[#1294F0] underline"
                  >
                    Form link </a
                  >.
                </li>
              </ol>

              <!-- Close Button -->
              <div class="mt-10 flex justify-center">
                <button
                  @click="closeModal('slotRules')"
                  type="button"
                  class="relative inline-flex items-center justify-center px-10 py-3 text-white border border-white rounded-md text-sm font-semibold uppercase hover:text-white hover:border-[#1294F0] hover:bg-[#1689DB]"
                >
                  Close
                  <span
                    class="absolute inset-x-0 bottom-0 h-1 bg-white mx-auto w-16"
                  ></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Sport Rules Modal -->
    <div
      v-show="sportRules"
      class="relative z-50"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="fixed inset-0 bg-black bg-opacity-70 transition-opacity"
        aria-hidden="true"
      ></div>
      <div
        class="fixed inset-0 z-10 w-screen overflow-y-auto"
        style="font-family: Oxanium, sans-serif"
      >
        <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
          <div
            v-motion-pop-visible
            class="relative overflow-hidden text-center shadow-xl sm:my-8 sm:w-full sm:max-w-xl rounded-[1rem] bg-[#1D1D1D]"
          >
            <div class="px-6 sm:px-10 pb-8 pt-6 sm:pt-10">
              <h3
                class="text-xl lg:text-3xl font-semibold text-white uppercase"
                id="modal-title"
              >
                KOTH SPORT BET RULES
              </h3>
              <ol
                class="list-decimal text-left text-white mt-6 text-sm lg:text-base tracking-wider ml-5 space-y-4"
              >
                <li>
                  <span class="font-bold">REGISTRATION LINK</span> - Use the code
                  <span class="text-[#1294F0] font-bold">"BALLYBOY"</span> on either
                  Metaspins or Dailyspins. You can also use these links:
                  <a
                    href="https://dailyspins.com/?ref=BALLYBOY"
                    target="_blank"
                    class="text-[#1294F0] underline"
                    >Dailyspins</a
                  >
                  or
                  <a
                    href="https://metaspins.com/?ref=BALLYBOY"
                    target="_blank"
                    class="text-[#1294F0] underline"
                    >Metaspins</a
                  >.
                </li>
                <li>
                  <span class="font-bold">NO MINIMUM BET REQUIRED</span> - The highest
                  winning bet slip in dollar amount wins the $1,000 at the end of the
                  timer.
                </li>
                <li>
                  <span class="font-bold">SPORTS SLIPS</span> - Must be submitted within
                  24 hours to be eligible to win.
                </li>
                <li>
                  <span class="font-bold">SUBMISSION LINK</span> - Submit your hit here:
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSdmwEFHpCi9C_kKZ0fnObYqHbM5PKpNuLzRZpvM_f45WpxBgA/viewform"
                    target="_blank"
                    class="text-[#1294F0] underline"
                    >Form link</a
                  >.
                </li>
              </ol>

              <!-- Close Button -->
              <div class="mt-10 flex justify-center">
                <button
                  @click="closeModal"
                  type="button"
                  class="relative inline-flex items-center justify-center px-10 py-3 text-white border border-white rounded-md text-sm font-semibold uppercase hover:text-white hover:border-[#1294F0] hover:bg-[#1689DB]"
                >
                  Close
                  <span
                    class="absolute inset-x-0 bottom-0 h-1 bg-white mx-auto w-16"
                  ></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    slotRules: {
      type: Boolean,
      required: true,
    },
    sportRules: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.cards-frame {
  background: #1d1d1d;
  border-radius: 1rem;
  padding: 1.5rem;
}
</style>
